import request from "@/utils/request";
// 立即登录
export function isLogin(data) {
  return request({
    url: `/college_service_hall_api/oauth2/doLogin`,
    method: "get",
    params: data,
  });
}
// 密码修改
export function updatePassword(data) {
  return request({
    url: `/college_service_hall_api/system/user/update-my-password`,
    method: "post",
    data,
  });
}
// 退出
export function logOut(params) {
  return request({
    url: `/college_service_hall_api/oauth2/logOut`,
    method: "post",
    params,
  });
}
// 文件上传
export function uploadFile(data) {
  return request({
    url: `/college_service_hall_api/file/upload`,
    method: "post",
    headers: { "Content-type": "multipart/form-data" },
    data,
  });
}
// 部门下拉数据
export function deptSimpleList(data) {
  return request({
    url: `/college_service_hall_api/system/dept/simple-list`,
    method: "post",
    data
  });
}
// 用户信息
export function userinfo() {
  return request({
    url: `/college_service_hall_api/oauth2/self/userinfo`,
    method: "post",
  });
}
// 注册用户
export function register(data) {
  return request({
    url: `/college_service_hall_api/system/user/register`,
    method: "post",
    data,
  });
}
//根据手机号查询注册记录列表
export function getRegisterListBy(params) {
  return request({
    url: `/college_service_hall_api/system/user/getRegisterListBy`,
    method: "post",
    params,
  });
}
